import i18next from 'i18next'
import React, { lazy, Suspense } from 'react'
import { any, async, fromJSX, StandardLocalWidget } from 'widgets-for-react'
import { RootLayout } from '../../site/root/rootLayout'
import { SubscriptionLayout } from '../../subscription/subscriptionLayout'
import {
  InvoiceSelectorState,
  invoiceSelectorStateUpdaters,
} from './invoiceSelectorState'

const InvoiceSelectorLayout = lazy(() => import('./invoiceSelectorLayout'))

export const invoiceSelectorWidget: StandardLocalWidget<
  InvoiceSelectorState
> = (currentState) =>
  any([
    async(currentState.invoices).map(invoiceSelectorStateUpdaters.invoices),
    fromJSX((setState) => (
      <SubscriptionLayout.Section title={i18next.t('subscription:Invoices')}>
        <SubscriptionLayout.Row id="account-invoice-selector">
          <SubscriptionLayout.Col kind="label">
            <p>{i18next.t('subscription:ChooseYear')}</p>
          </SubscriptionLayout.Col>
          <SubscriptionLayout.Col kind="value">
            <p>{i18next.t('subscription:InvoicesIntro')}</p>
            <Suspense fallback={<RootLayout.Loader showText hasWrapper />}>
              <InvoiceSelectorLayout
                year={currentState.year}
                onYearChange={(newValue) =>
                  setState(invoiceSelectorStateUpdaters.year(() => newValue))
                }
                invoices={currentState.invoices}
              />
            </Suspense>
          </SubscriptionLayout.Col>
        </SubscriptionLayout.Row>
      </SubscriptionLayout.Section>
    )),
  ])
